export const CAROUSEL_CATEGORIES = [
  { value: "IT", label: "IT 전문서" },
  { value: "HUMANITIES", label: "인문·교양" },
  { value: "BUSINESS", label: "비즈니스·자기계발" },
  { value: "AMAZON", label: "아마존 킨들" },
];

export const DEFAULT_CAROUSEL_CATEGORY = CAROUSEL_CATEGORIES[0].value;

const CAROUSEL_CATEGORY_VALUES = new Set(
  CAROUSEL_CATEGORIES.map((option) => option.value)
);

export const isValidCarouselCategory = (value) =>
  CAROUSEL_CATEGORY_VALUES.has(value);
